import { ObjectField } from "react3l-decorators";
import nameof from "ts-nameof.macro";
import { ProjectParticipant } from "./ProjectParticipant";

import { AppUser } from "models/AppUser";
import { Project } from "models/Project";
import { Role } from "models/Role";
import { Status } from "models/Status";

ObjectField(AppUser)(
  ProjectParticipant.prototype,
  nameof(ProjectParticipant.prototype.appUser)
);
ObjectField(Project)(
  ProjectParticipant.prototype,
  nameof(ProjectParticipant.prototype.project)
);
ObjectField(Role)(
  ProjectParticipant.prototype,
  nameof(ProjectParticipant.prototype.role)
);
ObjectField(Status)(
  ProjectParticipant.prototype,
  nameof(ProjectParticipant.prototype.status)
);

export * from "./ProjectParticipant";
export * from "./ProjectParticipantFilter";
